"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Search = void 0;
var React = __importStar(require("react"));
function Search(props) {
    return (React.createElement("svg", __assign({}, props, { xmlns: "http://www.w3.org/2000/svg", width: 33.695, height: 33.295, viewBox: "0 0 33.695 33.295" }),
        React.createElement("defs", null,
            React.createElement("filter", { id: "prefix__a", x: 22.494, y: 22.097, width: 11.201, height: 11.198, filterUnits: "userSpaceOnUse" },
                React.createElement("feOffset", { dx: 0.7, dy: 0.3 }),
                React.createElement("feGaussianBlur", { stdDeviation: 0.35, result: "blur" }),
                React.createElement("feFlood", { floodOpacity: 0.329 }),
                React.createElement("feComposite", { operator: "in", in2: "blur" }),
                React.createElement("feComposite", { in: "SourceGraphic" })),
            React.createElement("filter", { id: "prefix__b", x: 19.846, y: 19.745, width: 13.1, height: 13.2, filterUnits: "userSpaceOnUse" },
                React.createElement("feOffset", { dx: -1, dy: -1 }),
                React.createElement("feGaussianBlur", { stdDeviation: 0.5, result: "blur-2" }),
                React.createElement("feFlood", { floodColor: "#fff" }),
                React.createElement("feComposite", { operator: "in", in2: "blur-2" }),
                React.createElement("feComposite", { in: "SourceGraphic" })),
            React.createElement("filter", { id: "prefix__c", x: 2.648, y: 2.25, width: 27.596, height: 27.594, filterUnits: "userSpaceOnUse" },
                React.createElement("feOffset", { dx: 0.7, dy: 0.3 }),
                React.createElement("feGaussianBlur", { stdDeviation: 0.35, result: "blur-3" }),
                React.createElement("feFlood", { floodOpacity: 0.329 }),
                React.createElement("feComposite", { operator: "in", in2: "blur-3" }),
                React.createElement("feComposite", { in: "SourceGraphic" })),
            React.createElement("filter", { id: "prefix__d", x: 0, y: 0, width: 29.494, height: 29.494, filterUnits: "userSpaceOnUse" },
                React.createElement("feOffset", { dx: -1, dy: -1 }),
                React.createElement("feGaussianBlur", { stdDeviation: 0.5, result: "blur-4" }),
                React.createElement("feFlood", { floodColor: "#fff" }),
                React.createElement("feComposite", { operator: "in", in2: "blur-4" }),
                React.createElement("feComposite", { in: "SourceGraphic" }))),
        React.createElement("g", { "data-name": "Group 48243" },
            React.createElement("path", { "data-name": "Rectangle 25790", fill: "none", d: "M2.529 2.529h30v30h-30z" }),
            React.createElement("g", { "data-name": "loupe (1)" },
                React.createElement("g", { "data-name": "Group 44853" },
                    React.createElement("g", { "data-name": "Group 44852" },
                        React.createElement("g", { filter: "url(#prefix__a)", transform: "translate(-.004 -.004)" },
                            React.createElement("path", { "data-name": "Path 55725", d: "M31.6 29.936l-6.746-6.746a1.177 1.177 0 00-1.664 1.664l6.746 6.746a1.177 1.177 0 001.664-1.664z", fill: "#637691" })),
                        React.createElement("g", { filter: "url(#prefix__b)", transform: "translate(-.004 -.004)" },
                            React.createElement("path", { "data-name": "Path 59479", d: "M31.6 29.936l-6.746-6.746a1.177 1.177 0 00-1.664 1.664l6.746 6.746a1.177 1.177 0 001.664-1.664z", fill: "#637691", stroke: "#637691" })))),
                React.createElement("g", { "data-name": "Group 44851" },
                    React.createElement("g", { "data-name": "Group 44850" },
                        React.createElement("g", { filter: "url(#prefix__c)" },
                            React.createElement("path", { "data-name": "Path 55724", d: "M15.747 3a12.747 12.747 0 1012.747 12.747A12.762 12.762 0 0015.747 3zm0 23.141a10.394 10.394 0 1110.394-10.394 10.405 10.405 0 01-10.394 10.394z", fill: "#637691" })),
                        React.createElement("g", { filter: "url(#prefix__d)" },
                            React.createElement("path", { "data-name": "Path 59478", d: "M15.747 3a12.747 12.747 0 1012.747 12.747A12.762 12.762 0 0015.747 3zm0 23.141a10.394 10.394 0 1110.394-10.394 10.405 10.405 0 01-10.394 10.394z", fill: "#637691", stroke: "#637691" }))))))));
}
exports.Search = Search;
//# sourceMappingURL=Search.js.map